<template>
  <Modal :mask-closable="true" v-model="ModalShow" @on-cancel="close()" :width="newWith" :footer-hide="true" :scrollable="false" class-name="QHopen">
    <iframe :src="url" frameborder="0" :height="newHeight">加载中...</iframe>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      ModalShow: true,
      newWith: 0,
      newHeight: 0,
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 90,
    },
    height: {
      type: Number,
      default: 90,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.updateSize();
    // 添加窗口大小变化监听
    window.addEventListener("resize", this.handleWindowResize);
  },
  beforeDestroy() {
    // 移除监听器，防止内存泄漏
    window.removeEventListener("resize", this.handleWindowResize);
  },
  methods: {
    // 窗口大小变化处理函数
    handleWindowResize() {
      // 使用防抖优化性能，避免频繁触发
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.updateSize();
      }, 300);
    },
    updateSize() {
      //屏幕宽度
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      if (windowWidth > 1800) {
        var size = 90;
      } else if (windowWidth > 1600) {
        var size = 40;
      } else if (windowWidth > 1300) {
        var size = 20;
      } else {
        var size = 10;
      }
      var widthInit = windowWidth - size;
      var heightInit = windowHeight - size;
      if(widthInit<1200){
        widthInit=1200;
      }
      if(heightInit<500){
        heightInit=500;
      };
      this.newWith=widthInit;
      this.newHeight=heightInit;




    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style>
.QHopen {
  z-index: 100000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.QHopen .ivu-modal {
  top: 0 !important;
}
.QHopen .ivu-modal-header {
  display: none;
}
.QHopen .ivu-modal-body {
  padding: 0 !important;
  overflow: hidden;
  border-radius: 6px !important;
}
.QHopen iframe {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
  overflow-y: auto !important;
  display: block;
}
.QHopen .ivu-modal-close {
  background: #2d8cf0;
  border-radius: 300px;
}
.QHopen .ivu-modal-close .ivu-icon {
  color: #fff !important;
}
.QHopen .ivu-modal-content-drag {
  position: relative;
}
</style>
